import { render, staticRenderFns } from "./Memoriam.vue?vue&type=template&id=1e0aaf3a&scoped=true&"
import script from "./Memoriam.vue?vue&type=script&lang=js&"
export * from "./Memoriam.vue?vue&type=script&lang=js&"
import style0 from "./Memoriam.vue?vue&type=style&index=0&id=1e0aaf3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0aaf3a",
  null
  
)

export default component.exports